import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import heroSenso from '../../assets/images/senso.jpg';
import heroHaiXianLao from '../../assets/images/hai-xian-lao.jpg';
import heroMissG from '../../assets/images/miss-g.jpg';
import {Link} from "react-router-dom";


class ShiftPageMookata extends Component {
  componentDidMount() {
    window.analytics.page("Shift Listings");
  }

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles('Shifts on SingleShift')}
          {metaDescriptions('List of shifts on SingleShift right now.')}
          {metaImages(`${window.location.origin}${heroSenso}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <a href={'https://www.singleshift.sg/pros'}>
                  <img className={`logo ${classes.logo}`} src={logoBlack}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Senso */}
        <div className={classes.bizSection}>
          <div id='hero'>
            <div className='container'>
              <div className='row justify-content-md-center'>
                <div className='col-md-8 col-sm-12'>
                  <img src={heroSenso} className='img-fluid' width='940'/>
                </div>
              </div>
            </div>
          </div>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h1 className={classes.shiftName}>Senso Ristorante</h1>
                <p className={classes.shiftDate}>Telok Ayer (<a href={'https://goo.gl/maps/rsnv4UDrJMu'}>21 Club Street)</a></p>
                <p className='text-demphasis'>Established in 2000 on 21 Club Street, Senso Ristorante & Bar is well-known for its authentic Italian fine-dining cuisine and its impeccable service. Senso Ristorante & Bar firmly believes in maintaining its high standards of excellent food, warm and sophisticated atmosphere.</p>
              </div>
            </div>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Server ($14)</h3>
                <ul className='list-unstyled'>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/senso-ristorante-20sep18'}>Thursday, Sep 20 from 5:00PM to 10:30PM (Filled) </a></li>
                  <li><a href={'https://www.singleshift.sg/shifts/senso-ristorante-21sep18'}>Friday, Sep 21 from 5:00PM to 10:30PM</a></li>
                  <li><a href={'https://www.singleshift.sg/shifts/senso-ristorante-22sep18'}>Saturday, Sep 22 from 5:30PM to 10:30PM</a></li>
                </ul>
              </div>
            </div>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Cooks ($12)</h3>
                <ul className='list-unstyled'>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/senso-ristorante-20sep18-2'}>Thursday, Sep 20 from 5:30PM to 10:30PM  (Filled)</a></li>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/senso-ristorante-21sep18-2'}>Friday, Sep 21 from 5:30PM to 10:30PM (Filled)</a></li>
                  <li><a href={'https://www.singleshift.sg/shifts/senso-ristorante-22sep18-2'}> Saturday, Sep 22 from 11:00AM to 10:30PM</a></li>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/senso-ristorante-23sep18'}> Sunday, Sep 23 from 10:00AM to 3:00PM (Filled)</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Hai Xian Lao */}
        <div className={classes.bizSection}>
          <div id='hero'>
            <div className='container'>
              <div className='row justify-content-md-center'>
                <div className='col-md-8 col-sm-12'>
                  <img src={heroHaiXianLao} className='img-fluid' width='940'/>
                </div>
              </div>
            </div>
          </div>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h1 className={classes.shiftName}>Hai Xian Lao</h1>
                <p className={classes.shiftDate}>Dhoby Ghaut (<a href={'https://goo.gl/maps/nhfVQeRv4jE2'}>8 Wilkie Road Wilkie Edge #01-21, 228095</a>)</p>
                <p className='text-demphasis'>Fusion Steamboat Restaurant w Live Seafood! Our thick and flavorful collagen soup is brewed using the choicest ingredients! Guarantee to delight even the most die-hard steamboat connoisseur!</p>
              </div>
            </div>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Server ($10)</h3>
                <ul className='list-unstyled'>
                  <li><a href={'https://www.singleshift.sg/shifts/hai-xian-lao-21sep18'}>Friday, Sep 21 from 5:00PM to 10:30PM</a></li>
                  <li><a href={'https://www.singleshift.sg/shifts/hai-xian-lao-22sep18'}>Saturday, Sep 22 from 7:00PM to 11:00PM </a></li>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/hai-xian-lao-23sep18'}>Sunday, Sep 23 from 11:00AM to 5:00PM (Filled) </a></li>
                </ul>
              </div>
            </div>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Cooks ($10)</h3>
                <ul className='list-unstyled'>
                  <li><a className={classes.shiftLinkFilled} href={'https://www.singleshift.sg/shifts/hai-xian-lao-19sep18'}>Wednesday, Sep 19 from 6:00PM to 11:00PM  (Filled)</a></li>
                  {/* <li><a href={'https://www.singleshift.sg/shifts/hai-xian-lao-20sep18'}>Thursday, Sep 20 from 6:00PM to 11:00PM</a></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Miss G's Grill and Bar */}
        <div className={classes.bizSection}>
          <div id='hero'>
            <div className='container'>
              <div className='row justify-content-md-center'>
                <div className='col-md-8 col-sm-12'>
                  <img src={heroMissG} className='img-fluid' width='940'/>
                </div>
              </div>
            </div>
          </div>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h1 className={classes.shiftName}>Miss G's Grill and Bar</h1>
                <p className={classes.shiftDate}>Telok Ayer (<a href={'https://goo.gl/maps/f2jGFGsUCTx'}>44/45 Pekin Street, Singapore 048775</a>)</p>
                <p className='text-demphasis'>Located just a stone’s throw away from Telok Ayer MRT, Miss G’s Grill & Bar is the ideal location for a chill get-together with your friends. With a fairly extensive range of grub and alcohol — from $40 beer towers to sour plum shots ($72 for a dozen) and wines, there’s definitely something for everyone. </p>
              </div>
            </div>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Server ($10)</h3>
                <ul className='list-unstyled'>
                  <li><a href={'https://www.singleshift.sg/shifts/miss-gs-grill-bar-21sep18-2'}>Friday, Sep 21 from 4:00PM to 11:00PM</a></li>
                  <li><a href={'https://www.singleshift.sg/shifts/miss-gs-grill-bar-21sep18'}>Friday, Sep 21 from 4:00PM to 3:00AM</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}


export default withStyles((theme) => ({
  logo: {
    marginBottom: '30px',
  },
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  bizSection: {
    marginBottom: '90px',
  },
  shiftLinkFilled: {
    color: '#B4B3B3',
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftPageMookata);



// WEBPACK FOOTER //
// ./src/pages/shift-pages/ShiftPageList.js